import { Suspense } from "react";
import { Route, Routes } from "react-router";
import { PageLoading } from "~/components/loading";
import { GeoreferencerContainer } from "./components/georeferencer.container";

export function GeoreferencerRoutes() {
  return (
    <Suspense fallback={<PageLoading />}>
      <Routes>
        <Route index element={<GeoreferencerContainer />} />
      </Routes>
    </Suspense>
  );
}
